import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type {
  ProcessInfoQuery,
  ProcessInfoVo,
  CardBinQuery,
  CardBinDetailVo,
  DirectPayQuery,
  DirectPayVo,
  ProcessQuery,
  CardDelQuery,
  OrderDeliveryBo,
  OrderBuyerIframePrepareVo,
  OrderCreateByCartBo
} from './types';
/**
 * 直连支付流程信息
 * params: ProcessInfoQuery
 * return ProcessInfoVo
 */
export const processInfo = (params: ProcessInfoQuery): AxiosPromise<ProcessInfoVo> => {
  return request({
    url: '/payment/direct/process/info',
    method: 'get',
    params
  });
};

/**
 * 直连支付用户卡删除
 * data: CardDeleteQuery
 */
// export const cardDelete = (data: CardDeleteQuery) => {
//   return request({
//     url: '/payment/direct/card/delete',
//     method: 'post',
//     data
//   });
// };
/**
 * 卡bin查询
 * **/
export const binDetail = (params: CardBinQuery): AxiosPromise<CardBinDetailVo> => {
  return request({
    url: '/payment/card/bin/detail',
    method: 'get',
    params
  });
};

/**
 * 直连支付立即支付
 * data:
 */
export const directPay = (data: DirectPayQuery): AxiosPromise<DirectPayVo> => {
  return request({
    url: '/payment/direct/pay',
    method: 'post',
    data
  });
};

/**
 * continueProcess 3ds验证
 * data:
 */
export const continueProcess = (params: ProcessQuery): AxiosPromise<DirectPayVo> => {
  return request({
    url: '/payment/direct/continue',
    method: 'get',
    params
  });
};

/**
 * 用户卡删除
  POST /payment/user/card/delete
  接口ID：259302483
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-259302483
 */
export const cardDelete = (data: CardDelQuery): AxiosPromise<{ [key: string]: any }> => {
  return request({
    url: '/payment/user/card/delete',
    method: 'post',
    data
  });
};

// iframe购买准备
// POST /order/order/buyer/buy/iframe/prepare
// 接口ID：322347198
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-322347198
export const stripeIframePayPre = (data: OrderDeliveryBo): AxiosPromise<OrderBuyerIframePrepareVo> => {
  return request({
    url: '/order/order/buyer/buy/iframe/prepare',
    method: 'post',
    data
  });
};

// 购物车iframe购买准备
// POST /order/order/buyer/buy/cart/iframe/prepare
// 接口ID：322347199
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-322347199
export const stripeIframeCartPayPre = (data: OrderCreateByCartBo): AxiosPromise<OrderBuyerIframePrepareVo> => {
  return request({
    url: '/order/order/buyer/buy/cart/iframe/prepare',
    method: 'post',
    data
  });
};
